import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/login";
import Dashboard from "./pages/dashboard";
import Forgetpassword from "./pages/forgetpassword";
import ResetPassword from "./pages/resetPassword";
import { socket } from "../src/socket";
import { useEffect, useState } from "react";

import VendorLocation from "./pages/vendorLocation";
import VendorsList from "./pages/vendorsList";
import Queries from "./pages/queries";
import Reports from "./pages/reports";
import TruckDetails from "./pages/truckDetails";
import Reqlist from "./pages/reqlist";

import VendorLocationsample from "./pages/vendorsample";
import AddaAvatar from "./pages/avatarGallery";

function App() {
  const [setIsConnected] = useState(socket.connected);
  const [setFooEvents] = useState([]);

  useEffect(() => {
    function onConnect() {
      setIsConnected(true);
    }

    function onDisconnect() {
      setIsConnected(false);
    }

    function onFooEvent(value) {
      setFooEvents((previous) => [...previous, value]);
    }

    socket.on("connect", () => {
      console.log("socket connected ");
    });

    socket.on("disconnect", onDisconnect);
    socket.on("foo", onFooEvent);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("foo", onFooEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/forgetpassword" element={<Forgetpassword />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/locations" element={<VendorLocation />} />
          <Route path="/vendorslist" element={<VendorsList />} />
          <Route path="/truckDetails" element={<TruckDetails />} />
          <Route path="/locationsample" element={<VendorLocationsample />} />
          <Route path="/queries" element={<Queries />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/requests" element={<Reqlist />} />
          <Route path="/avatargallery" element={<AddaAvatar />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
